export type MoveDirection = 'up' | 'down';

export class ArrayHelper {
	moveItemInArray<T = any>(array: T[], fromIndex: number, toIndex: number): void {
		const from = this.clamp(fromIndex, array.length - 1);
		const to = this.clamp(toIndex, array.length - 1);

		if (from === to) {
			return;
		}

		const target = array[from];
		const delta = to < from ? -1 : 1;

		for (let i = from; i !== to; i += delta) {
			array[i] = array[i + delta];
		}

		array[to] = target;
	}

	moveItem<T>(items: T[], index: number, direction: MoveDirection): readonly T[] {
		if (direction === 'up') {
			if (!this.canMoveUp(items, index)) {
				return items;
			}

			const previousIndex: number = index;
			const newIndex: number = index - 1;

			this.moveItemInArray(items, previousIndex, newIndex);
		} else if (direction === 'down') {
			if (!this.canMoveDown(items, index)) {
				return items;
			}

			const previousIndex: number = index;
			const newIndex: number = index + 1;

			this.moveItemInArray(items, previousIndex, newIndex);
		} else {
			throw Error(`Invalid direction '${direction}'`);
		}

		return items;
	}

	canMoveDown<T>(items: readonly T[], index: number): boolean {
		if (!items.length) {
			return false;
		}

		if (index === items.length - 1) {
			return false;
		}

		return true;
	}

	canMoveUp<T>(items: readonly T[], index: number): boolean {
		if (!items.length) {
			return false;
		}

		if (index <= 0) {
			return false;
		}

		return true;
	}

	getUniqueValues(values: string[]): string[] {
		const uniqueValues: string[] = [];

		for (const value of values) {
			if (!uniqueValues.find((m) => m === value)) {
				uniqueValues.push(value);
			}
		}

		return uniqueValues;
	}

	private clamp(value: number, max: number): number {
		return Math.max(0, Math.min(max, value));
	}
}

export const arrayHelper = new ArrayHelper();
